/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import moment from 'moment-timezone'
import { DATE_FORMATS } from 'constants/dates'

export const getYearsDuration = addedYears => {
  const date = moment()
  const start = date.year()
  const end = date.add(addedYears, 'years').year()
  return [
    start,
    end,
  ]
}

export const getPrintedDateWithTime = date => {
  return moment.utc(date).format(DATE_FORMATS.printedWithTime)
}

export const getPrintedDate = date => {
  return moment.utc(date).format(DATE_FORMATS.printed)
}

export const getPrintedDateWithTimeLocal = date => {
  return moment.utc(date).local().format(DATE_FORMATS.printedWithTime)
}

export const getPrintedDateLocal = date => {
  return moment.utc(date).local().format(DATE_FORMATS.printed)
}

export const getEndCurrentDayTimestamp = () => moment.utc().endOf('day').valueOf()

export const getUtcOffset = () => moment.utc().utcOffset()

export const getCurrentYearNumber = () => moment().year()

export const getCurrentMonthIndex = () => moment().month()

export const checkIsCardExpired = (expirationMonth, expirationYear) => {
  const expirationDate = moment(`20${expirationYear}-${expirationMonth}-1`)
  const currentDate = moment()

  expirationDate.add(1, 'months')

  return currentDate.isSameOrAfter(expirationDate)
}

export const isDateAfter = (dateA, dateB) => {
  return moment(dateA).isAfter(moment(dateB))
}

export const isContractExpired = (contractEndDate) => {

  if (!contractEndDate) {
    return false
  }
  
  let currentDateTime = moment().tz('America/Los_Angeles').format()
  // contract expires at 12 AM next day
  let contractDateTime = moment(contractEndDate).tz('America/Los_Angeles').startOf('day').add(1, 'days').format()

  return isDateAfter(currentDateTime, contractDateTime)
}
